<template>
    <div class="success-notification">
        <p class="text text-center p-4">{{ notification }}</p>
    </div>
</template>

<script>
export default {
  name: 'SuccessMessage',
  props: ['notification']
}
</script>

<style lang="scss" scoped>
.success-notification {
    color: $success-green;
    font-size: 16px;
    background-color: $success-light-green;
    border: solid 1px $success-green;
    border-radius: 0px;
}
</style>
